import { useNavigate } from 'react-router-dom';
import '../../css/home/PopularCompetitions.css';
import { Icon, maskStyle } from '../../utils/icons';
import FavStar from '../shared/FavStar';

const COMPETITIONS = [
  { name: 'Premier League', sport: 'sport-football',   color: '#0f891f', flag: 'england', path: '/football'          },
  { name: 'La Liga',        sport: 'sport-football',   color: '#0f891f', flag: 'spain',   path: '/football'          },
  { name: 'Serie A',        sport: 'sport-football',   color: '#0f891f', flag: 'italy',   path: '/football'          },
  { name: 'Bundesliga',     sport: 'sport-football',   color: '#0f891f', flag: 'germany', path: '/football'          },
  { name: 'Ligue 1',        sport: 'sport-football',   color: '#0f891f', flag: 'france',  path: '/football'          },
  { name: 'NBA',            sport: 'sport-basketball', color: '#fca601', flag: 'usa',     path: '/basketball'        },
  { name: 'WTA Finals',     sport: 'sport-tennis',     color: '#f8c83c', flag: 'world',   path: '/tennis'            },
  { name: 'NHL',            sport: 'sport-hockey',     color: '#c8ec1a', flag: 'canada',  path: '/ice-hockey'        },
];

const FLAGS = {
  italy:   'linear-gradient(90deg,#009246 33%,#fff 33% 66%,#ce2b37 66%)',
  spain:   'linear-gradient(180deg,#aa151b 25%,#f1bf00 25% 75%,#aa151b 75%)',
  germany: 'linear-gradient(180deg,#000 33%,#dd0000 33% 66%,#ffce00 66%)',
  france:  'linear-gradient(90deg,#0055a4 33%,#fff 33% 66%,#ef4135 66%)',
  usa:     'linear-gradient(90deg,#002868 33%,transparent 0),repeating-linear-gradient(180deg,#b22234 0 2px,#fff 2px 4px)',
  canada:  'linear-gradient(90deg,#d52b1e 25%,#fff 25% 75%,#d52b1e 75%)',
  england: 'linear-gradient(#cf0a23,#cf0a23) 50% 0/20% 100% no-repeat, linear-gradient(#cf0a23,#cf0a23) 0 50%/100% 21% no-repeat, #fff',
  world:   'linear-gradient(180deg,#1a6bb5 40%,#fff 40% 60%,#1a6bb5 60%)',
};

export default function PopularCompetitions() {
  const navigate = useNavigate();

  return (
    <div className="popcomp">
      {COMPETITIONS.map((c, i) => (
        <div
          key={i}
          className="popcomp-row"
          onClick={() => c.path && navigate(c.path)}
          style={{ cursor: c.path ? 'pointer' : 'default' }}
        >
          <FavStar
            item={{
              id: `pop-${c.path}-${c.name}`,
              type: 'league',
              name: c.name,
              meta: '',
              sport: c.path ? c.path.slice(1) : undefined,
            }}
            size={15}
          />
          <Icon className="popcomp-sport" name={c.sport} w={14} h={14} color={c.color} />
          <span className="popcomp-name">{c.name}</span>
          <span className="popcomp-flag" style={{ background: FLAGS[c.flag] }} />
          <span className="popcomp-chevron" style={maskStyle('ic-chevron')} />
        </div>
      ))}
    </div>
  );
}
